import { render } from "./UsersSelectComponent.vue?vue&type=template&id=5cdc33c5"
import script from "./UsersSelectComponent.vue?vue&type=script&lang=js"
export * from "./UsersSelectComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/app/natviol-app/releases/880/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__